// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

export const OpenWizardButton = ({ onOpenWizard }) => {
  const { t } = useTranslation();
  return (
    <>
      <Button data-cy="open-technical-policy-dialog-button" variant="contained" color="primary" onClick={onOpenWizard}>
        {t('genericcomponent.common.configure', 'CONFIGURE')}
      </Button>
    </>
  );
};
OpenWizardButton.propTypes = {
  onOpenWizard: PropTypes.func.isRequired,
};
